import { LoansConfigTypes } from "./types/loans-config-types";

export const LoansConfig: LoansConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
